// App Branding Configuration
// Change these values to update branding across the entire app

const appConfig = {
  // App Name
  name: 'Wheels4Rent',

  // Logo — change this one place to update everywhere
  logo: '/logo.png',

  // Default cover image for travel-agency owners who haven't uploaded their own
  defaultTravelsCover: 'https://res.cloudinary.com/dfg39dktd/image/upload/v1779646587/car-rentals/cars/car-1779646583314-361943264.png',

  // Tagline Options - uncomment the one you want to use
  tagline: 'Rent | Buy | Sell | Manage',
  // tagline: 'Your Complete Vehicle Solution',
  // tagline: 'One App. All Wheels.',
  // tagline: 'Every Vehicle. Every Need.',
  // tagline: 'Rentals • Sales • Fleet Management',

  // Short description
  description: 'Find & book vehicles near you — Cars, Bikes, Buses, Trucks & More',

  // Hero section
  hero: {
    title: 'Explore Vehicles',
    subtitle: 'Find & book vehicles near you — Cars, Bikes, Buses, Trucks & More'
  },

  // For SEO / Page titles
  fullName: 'Wheels4Rent - Vehicle Rental & Sales Platform',

  // Contact Info
  contact: {
    phone: '+91 8088480197',
    email: 'wheels4rentsupport@gmail.com',
    website: 'www.wheels4rent.in'
  },

  // Legal / compliance. India's IT intermediary rules require a named grievance
  // officer with contact details published on the site; the DPDP Act requires a
  // data-protection contact. Details below are from the Udyam registration.
  legal: {
    companyName: 'Wheels4Rent',
    businessType: 'Sole Proprietorship (Udyam / MSME registered)',
    udyamNumber: 'UDYAM-KR-03-0713105',
    enterpriseType: 'Micro Enterprise',
    address: '53/48, Vajranivasa, 1st Main Road, Marenahalli, Vijayanagar, Bengaluru, Karnataka 560040',
    // IT Rules want a named individual. Replace with the proprietor's own name.
    grievanceOfficer: 'Proprietor — Wheels4Rent',
    grievanceEmail: 'wheels4rentsupport@gmail.com',
    // Public support line, not a personal number. Leave '' to publish email only.
    grievancePhone: '+91 8088480197',
    lastUpdated: 'July 2026',
  },

  // UPI payment details — shown as a scannable QR on the Subscription upgrade modal.
  // After paying, owners confirm via call/email and the team activates the plan.
  // Set REACT_APP_UPI_ID / REACT_APP_UPI_PAYEE to collect on a different account
  // without a code change (same pattern as the partner app's UPI_ID env var).
  payment: {
    upiId: process.env.REACT_APP_UPI_ID || 'vasu.gt555-3@okicici',
    payeeName: process.env.REACT_APP_UPI_PAYEE || 'Wheels4Rent'
  },

  // Social Media Links
  social: {
    facebook: 'https://facebook.com/wheels4rent',
    instagram: 'https://instagram.com/wheels4rent',
    twitter: 'https://twitter.com/wheels4rent'
  },

  // App Colors (for future use)
  colors: {
    primary: '#2563eb',    // Blue
    secondary: '#16a34a',  // Green
    accent: '#f59e0b'      // Orange
  },

  // Copyright
  copyright: `© ${new Date().getFullYear()} Powered by Samruddhi Technologies`,

  // Owner registration benefits
  ownerBenefits: [
    'Rent out your vehicles',
    'Sell vehicles online',
    'Manage bookings & drivers',
    'Track maintenance & expenses'
  ],

  // Features for owner banner
  ownerFeatures: [
    {
      title: 'Fleet Management',
      description: 'Add & manage unlimited vehicles',
      color: 'blue'
    },
    {
      title: 'Booking System',
      description: 'Receive & manage bookings easily',
      color: 'green'
    },
    {
      title: 'Driver Management',
      description: 'Assign drivers to trips',
      color: 'purple'
    },
    {
      title: 'Sell Vehicles',
      description: 'List vehicles for sale online',
      color: 'orange'
    }
  ]
};

export default appConfig;
